import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./AboutPage.css";

function AboutPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <Helmet>
        <title>About - RenuAirHub</title>
        <meta
          name="description"
          content="About RenuAirHub — a free flight information display system for African airports. Track departures, arrivals, and compare flight prices."
        />
        <link rel="canonical" href="https://renuairhub.com/about" />
      </Helmet>

      <div className="about-header">
        <button className="about-back" onClick={() => navigate(-1)}>
          <ArrowBackIcon fontSize="small" />
        </button>
        <h1 className="about-logo">RenuAirHub</h1>
      </div>

      <div className="about-content">
        <h2>{t("about.title")}</h2>

        <section>
          <h3>{t("about.whatTitle")}</h3>
          <p>{t("about.whatContent")}</p>
        </section>

        <section>
          <h3>{t("about.missionTitle")}</h3>
          <p>{t("about.missionContent")}</p>
        </section>

        <section>
          <h3>{t("about.featuresTitle")}</h3>
          <ul>
            <li>{t("about.feature1")}</li>
            <li>{t("about.feature2")}</li>
            <li>{t("about.feature3")}</li>
            <li>{t("about.feature4")}</li>
            <li>{t("about.feature5")}</li>
          </ul>
        </section>

        <section>
          <h3>{t("about.airportsTitle")}</h3>
          <p>{t("about.airportsContent")}</p>
        </section>

        <section className="about-affiliate-disclosure">
          <h3>{t("about.affiliateTitle")}</h3>
          <p>{t("about.affiliateContent")}</p>
        </section>

        <section>
          <h3>{t("about.contactTitle")}</h3>
          <p>
            {t("about.contactContent")}{" "}
            <a
              href="/contact"
              onClick={(e) => {
                e.preventDefault();
                navigate("/contact");
              }}
            >
              {t("about.contactLink")}
            </a>
          </p>
        </section>
      </div>

      <div className="about-footer">
        <p>
          © {new Date().getFullYear()} RenuAirHub. {t("about.allRights")}
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
